export default {
  title: "Portfolio",
  totalBalance: "Total balance",
  wallet: "Wallet",
  tvl: "TVL",
  price: "Price",
  marketcap: "Marketcap",
  pool: "Pool",
  liquidity: "Liquity",
  apr: "APR",
  deposited: "Deposited",
  rewards: "Rewards",
  claim: "Claim",
  claimAll: "Claim all",
  available: "Available",
  staked: "Staked",
  obtainLP: "Obtain LP",
  depositLP: "Deposit LP",
  poolsTitle: "Pools",
  token: "Token",
  tokens: "Tokens",
  quantity: "Quantity",
  amount: "Amount",
  value: "Value",
  increase: "Increase",
  info: "Info",
  viewContract: "View contract",
  addLP: "Add LP to your wallet",
  seeMore: "See more",
  seeLess: "See less",
  noRewards: "You don't have any rewards yet.",
  noPools: "You don't have any pools yet.",
  noTokens: "You don't have any tokens yet.",
  noNFTs: "You don't have any NFTs yet.",
  nft: "NFT",
  lock: "Blocked",
  deposits: "Deposits",
  noDeposits: "You don't have any deposits yet.",
  staking: "Staking",
  type: "Type",
}
